<template>
    <div class="section blank text-center">
        <h2>{{ $t('noItems') }}</h2>
        <div class="empty-list">
            <div class="icon">
                <svg
                    data-v-275b2de2=""
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 44 40"
                    aria-labelledby="box"
                    role="presentation"
                >
                    <title data-v-275b2de2="" id="box" lang="en">box</title>
                    <g data-v-275b2de2="" fill="currentColor">
                        <g
                            data-v-275b2de2=""
                            id="Page-1"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                        >
                            <g
                                data-v-275b2de2=""
                                id="noun_desert_2721931"
                                transform="translate(-18.000000, 0.000000)"
                                fill="currentColor"
                                fill-rule="nonzero"
                            >
                                <g data-v-275b2de2="" id="Group" transform="translate(18.000000, 0.000000)">
                                    <path
                                        data-v-275b2de2=""
                                        d="M29.5,34.5 L32,34.5 C33.3807119,34.5 34.5,35.6192881 34.5,37 C34.5,38.3807119 33.3807119,39.5 32,39.5 L3,39.5 C1.6192881,39.5 0.5,38.3807119 0.5,37 C0.5,35.6192881 1.6192881,34.5 3,34.5 L7,34.5 L7,22.5 L6.5,22.5 C3.4624339,22.5 1,20.0375661 1,17 C1,15.8954305 1.8954305,15 3,15 C4.1045695,15 5,15.8954305 5,17 C5,17.8284271 5.6715729,18.5 6.5,18.5 L7,18.5 L7,10.5751304 C7,9.4705609 7.8954305,8.5751304 9,8.5751304 C10.1045695,8.5751304 11,9.4705609 11,10.5751304 L11,22.5 L11.5,22.5 C12.3284271,22.5 13,21.8284271 13,21 L13,18 C13,16.8954305 13.8954305,16 15,16 C16.1045695,16 17,16.8954305 17,18 L17,21 C17,24.0375661 14.5375661,26.5 11.5,26.5 L11,26.5 L11,34.5 L19.5,34.5 L19.5,30.5 C19.5,29.3954305 20.3954305,28.5 21.5,28.5 C22.6045695,28.5 23.5,29.3954305 23.5,30.5 L23.5,34.5 L25.5,34.5 L25.5,28.5 C25.5,27.3954305 26.3954305,26.5 27.5,26.5 C28.6045695,26.5 29.5,27.3954305 29.5,28.5 L29.5,34.5 Z M36,16 C31.581722,16 28,12.418278 28,8 C28,3.581722 31.581722,0 36,0 C40.418278,0 44,3.581722 44,8 C44,12.418278 40.418278,16 36,16 Z M36,12 C38.209139,12 40,10.209139 40,8 C40,5.790861 38.209139,4 36,4 C33.790861,4 32,5.790861 32,8 C32,10.209139 33.790861,12 36,12 Z"
                                        id="Shape"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
        </div>
        <p class="m0">
            {{ $t('abitEmpty') }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'emptyList',
    i18n: {
        messages: {
            en: {
                abitEmpty: 'Looks a bit empty...',
                noItems: 'No items',
            },
            fr: {
                abitEmpty: 'Semble un peu vide...',
                noItems: 'Aucun élément',
            },
            nl: {
                abitEmpty: 'Ziet er een beetje leeg uit...',
                noItems: 'Geen gegevens',
            },
        },
    },
};
</script>

<style lang="scss">
.empty-list {
    text-align: center;
    padding: 10px;
    .icon {
        color: var(--color-txt);
        opacity: 0.4;
        &,
        & svg {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
